import { TableFilters, SearchableSelect } from '../../design-system';
import { useStore } from '../../context';
import { belongsToOptions } from '../../services';
import { showToRoles } from '../../utils';
import { i18n } from '../../i18n';

interface Props {
  yardName?: string;
  yardId?: string;
  setStates: any;
}

export const Filters: React.FC<Props> = ({ yardName = '', yardId = '', setStates }: Props) => {
  const {
    state: {
      user: { data: user },
    },
  } = useStore();

  return (
    <TableFilters>
      {showToRoles(['SUPER_ADMIN', 'YARD_COMPANY_ADMIN', 'YARD_COMPANY_VIEWER'], user) && (
        <SearchableSelect
          selectedOptionLabel={yardName}
          label={i18n.t('common.yard')}
          onSelect={(obj) => setStates('force', { yardId: obj.id, yardName: obj.label })}
          queryFn={() => () => belongsToOptions.Yard('', true, 'yard')}
          queryKey={['yard', 'Yard']}
          selectedAreasEqaul={{ key: 'id', keys: [yardId] }}
          withClearButton
        />
      )}
    </TableFilters>
  );
};
